import { IProduct } from "@faire/web-api/indigofair/data/IProduct";
import { StrictLocalizeFunction } from "@faire/web/common/localization";

export const getVariantDescriptorSuffixDropdown = (
  variationState: keyof typeof IProduct.State | undefined,
  strictLocalize: StrictLocalizeFunction
): undefined | string => {
  if (variationState === undefined) {
    return strictLocalize({
      defaultMessage: "(Unavailable)",
      description: {
        text: "Note added to the end of a description. Product option is unavailable for an undisclosed reason.",
      },
    });
  }

  if (variationState === IProduct.State.SALES_PAUSED) {
    return strictLocalize({
      defaultMessage: "(Out of stock)",
      description: {
        text: "Note added to the end of a description. Product option is out of stock.",
      },
    });
  }

  return;
};

export const getVariantDescriptorSuffix = (
  variationState: keyof typeof IProduct.State | undefined,
  strictLocalize: StrictLocalizeFunction
): undefined | string => {
  if (variationState === undefined) {
    return strictLocalize({
      defaultMessage: "Unavailable",
      description: {
        text: "Note added to the end of a description. Product option is unavailable for an undisclosed reason.",
      },
    });
  }

  if (variationState === IProduct.State.SALES_PAUSED) {
    return strictLocalize({
      defaultMessage: "Out of stock",
      description: {
        text: "Note added to the end of a description. Product option is out of stock.",
      },
    });
  }

  return;
};
